import React from 'react'

import { classnames, Icon, Check } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, oneOfType, string } from 'prop-types'

import formatPlanPrice from '../../Utils/formatPlanPrice'
import translatePlansRestructure from '../../Utils/translatePlansRestructure'

const translate = (key, options) => translatePlansRestructure(`onetime.${key}`, options)

const formatsBenefit = (formatsCount) => {
  if (formatsCount > 1) return translate('bullets.formats', { count: formatsCount })
  if (formatsCount === 1) return translate('bullets.single_format')

  return null
}

function OnetimePurchase({
  price = null, originalPrice = null, formatsCount = 0, isCompact = false,
}) {
  const priceContent = (
    <>
      {originalPrice !== null && (
        <span className="pricing-area__onetime-original-price cgt-body-md">{formatPlanPrice(originalPrice)}</span>
      )}
      <span
        className={classnames('pricing-area__onetime-current-price', isCompact ? 'cgt-heading-400' : 'cgt-heading-500')}
      >
        {formatPlanPrice(price)}
      </span>
    </>
  )

  if (isCompact) {
    return (
      <div className="pricing-area__content pricing-area__content--purchase pricing-area__content--onetime">
        <div className="pricing-area__onetime-compact">
          <span className="pricing-area__onetime-compact-title cgt-body-md-semibold">{translate('title')}</span>
          <div className="pricing-area__onetime-price pricing-area__onetime-price--compact">{priceContent}</div>
        </div>
      </div>
    )
  }

  const benefits = [
    translate('bullets.license'),
    formatsBenefit(formatsCount),
    translate('bullets.instant_download'),
  ].filter(Boolean)

  return (
    <div className="pricing-area__content pricing-area__content--purchase pricing-area__content--onetime">
      <div className="pricing-area__onetime-header">
        <span className="pricing-area__onetime-label cgt-overline-md">{translate('title')}</span>
        <span className="pricing-area__onetime-license cgt-overline-md">{translate('license_tag')}</span>
      </div>
      <div className="pricing-area__onetime-price">{priceContent}</div>
      <ul className="pricing-area__onetime-benefits">
        {benefits.map((benefit) => (
          <li key={benefit} className="pricing-area__onetime-benefit cgt-body-base">
            <Icon svgComponent={Check} size="small" notSpaced className="pricing-area__onetime-benefit-icon" />
            {benefit}
          </li>
        ))}
      </ul>
    </div>
  )
}

OnetimePurchase.propTypes = {
  price: oneOfType([number, string]),
  originalPrice: oneOfType([number, string]),
  formatsCount: number,
  isCompact: bool,
}

export default OnetimePurchase
